import React from 'react';

const AccountsSVGOld = ({ className, parentClassName }) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={parentClassName}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.1037 6.22223C22.1037 6.73629 21.7077 7.15556 21.2222 7.15556C20.7367 7.15556 20.3407 6.73629 20.3407 6.22223H18.5778C18.5778 6.73629 18.1818 7.15556 17.6963 7.15556C17.2108 7.15556 16.8148 6.73629 16.8148 6.22223H15.0519C15.0519 6.73629 14.6559 7.15556 14.1704 7.15556C13.6849 7.15556 13.2889 6.73629 13.2889 6.22223H11.5259C11.5259 6.73629 11.1299 7.15556 10.6444 7.15556C10.1589 7.15556 9.76296 6.73629 9.76296 6.22223H8.88148C8.39598 6.22223 8 6.6415 8 7.15556V23.9556C8 24.4696 8.39598 24.8889 8.88148 24.8889H9.76296C9.76296 24.3748 10.1589 23.9556 10.6444 23.9556C11.1299 23.9556 11.5259 24.3748 11.5259 24.8889H13.2889C13.2889 24.3748 13.6849 23.9556 14.1704 23.9556C14.6559 23.9556 15.0519 24.3748 15.0519 24.8889H16.8148C16.8148 24.3748 17.2108 23.9556 17.6963 23.9556C18.1818 23.9556 18.5778 24.3748 18.5778 24.8889H20.3407C20.3407 24.3748 20.7367 23.9556 21.2222 23.9556C21.7077 23.9556 22.1037 24.3748 22.1037 24.8889H22.9852C23.4707 24.8889 23.8667 24.4696 23.8667 23.9556V7.15556C23.8667 6.6415 23.4707 6.22223 22.9852 6.22223H22.1037ZM20.3408 19.1547H11.526C11.0405 19.1547 10.6445 18.7354 10.6445 18.2214C10.6445 17.7073 11.0405 17.288 11.526 17.288H20.3408C20.8263 17.288 21.2223 17.7073 21.2223 18.2214C21.2223 18.7354 20.8263 19.1547 20.3408 19.1547ZM20.3408 13.823H11.526C11.0405 13.823 10.6445 13.4038 10.6445 12.8897C10.6445 12.3757 11.0405 11.9564 11.526 11.9564H20.3408C20.8263 11.9564 21.2223 12.3757 21.2223 12.8897C21.2223 13.4038 20.8263 13.823 20.3408 13.823Z"
      fill="none"
      className={className}
    />
  </svg>
);

const AccountsSVG = ({ className }) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M15.2619 7.42859H9.30977C9.30977 7.42859 5.14282 11.3981 5.14282 16.0305C5.14282 18.6763 6.93474 20 8.11888 20H16.4525C17.6416 20 19.4285 18.6762 19.4285 16.0305C19.4285 11.3981 15.2616 7.42859 15.2616 7.42859H15.2619ZM12.8804 16.6246V17.684H11.6913L11.6911 16.6281C10.8147 16.447 10.2642 15.8458 10.2251 14.9729H11.2563C11.3067 15.4311 11.7222 15.7263 12.3233 15.7263C12.8771 15.7263 13.2697 15.4276 13.2697 15.002C13.2697 14.6399 13.0156 14.4333 12.3901 14.2777L11.7271 14.1202C10.7985 13.9047 10.3424 13.3668 10.3424 12.503C10.3424 11.6392 10.8604 11.0162 11.6847 10.8116V9.7448H12.8738V10.8132C13.6785 11.0124 14.2145 11.6227 14.2405 12.443L13.2452 12.4431C13.1948 11.9958 12.82 11.6971 12.3053 11.6971C11.7906 11.6971 11.4191 11.9723 11.4191 12.4033C11.4191 12.7529 11.6618 12.9467 12.2596 13.0951L12.8738 13.24C13.8984 13.479 14.3398 13.9643 14.3398 14.8499C14.3399 15.797 13.7926 16.4308 12.8804 16.6246L12.8804 16.6246Z"
      fill="none"
      className={className}
    />
    <path
      d="M15.859 4.11164H13.8837C13.4757 3.67684 12.8951 3.42859 12.2858 3.42859C11.6766 3.42859 11.096 3.67686 10.6879 4.11164H8.7127C8.47642 4.11256 8.25597 4.22555 8.12336 4.4134C7.99076 4.60124 7.96321 4.83994 8.0497 5.05125L8.71268 6.85716H15.8587L16.5217 5.05125C16.6082 4.83994 16.5807 4.60125 16.4481 4.4134C16.3155 4.22554 16.095 4.11256 15.8587 4.11164H15.859Z"
      fill="none"
      className={className}
    />
  </svg>
);

export { AccountsSVG };
